import React, { Component } from 'react';
// import ReactTable from "react-table"
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import { DialogComponent } from '@syncfusion/ej2-react-popups';


class ProcedureAdmin extends Component {
    constructor() {
        super();
        this.dialogClose = () => {
            this.setState({ hideDeletePopup: false, });
        };

        this.settings = { effect: 'Zoom', duration: 400, delay: 0 };

        //for delete dialog component ok click
        this.buttons = [{
            buttonModel: {
                content: 'Yes',
                cssClass: 'e-flat',
                isPrimary: true,

            },
            'click': props => {
                this.deleteAdminApi(this.state.propsId)
                this.setState({ disabled: false })

            }
        }
            , {
            buttonModel: {
                content: 'No',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.setState({
                    hideDeletePopup: false,
                    disabled: false
                });
            }
        }];

        this.state = {
            language: null,
            data: [
                {
                    id: '',
                    answer: '',
                    originalQuestionId: '',
                    // categoryTags: '',
                    autoTranslate: '',
                    alias: '',
                }
            ],
            pageNum: null,
            faqid: '',
            disabled: false,
            editedId: '-1',
            editImageSrc: './assets/images/edit2.png',
            hidden: false,
            hideAddDialog: false,
            hideupdateDialog: false,
            hideDeletePopup: false,
            hideDeleteSuccessPopup: false
        }
        this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
        this.editImageSrc = "./assets/images/edit2.png";
    }

    NotifyFailToLoad() {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>Oops! Error occurred.Please try again</b>, {
            position: "top-center",
            color: "red"
        });
    }

    addRow = (data) => {
        var ansController = this;
        if (ansController.state.pageNum != 0) {
            ansController.setState({ pageNum: 0 })
        }
        this.state.data.unshift({
            id: '',
            answer: '',
            autoTranslate: '',
        });
        this.setState({
            data: this.state.data,
            disabled: true
        })
    }
    notifyImproperEmailId() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please provide a valid email id</b>, {
            position: "top-center"
        });

    }
    notifyImproperContactNumber() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please provide a valid contact number</b>, {
            position: "top-center"
        });
    }
    notifyResponse(response) {
        toast.dismiss();
        toast(<b>{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }
    addAdminApi = (props, e) => {

        var thisController = this;

        var adminName = document.getElementById("adminName" + props.index).innerText.trim();
        var adminContactNumber = document.getElementById("adminContactNumber" + props.index).innerText.trim();
        var adminEmailId = document.getElementById("adminEmailId" + props.index).innerText.trim();
        var contactNumberPattern = new RegExp(/^(?!.*\s\s)[+]?[\d- ]{5,15}$/);
        // new RegExp(/^(?=.*\d).+$/);
        var namePattern = new RegExp(/^([a-zA-Z\s])*$/);

        var emailpattern = new RegExp(/[a-zA-Z][a-zA-Z0-9]+@(?:[a-zA-Z0-9]+\.)+[A-Za-z]+$/);

        if (adminName == "" || adminContactNumber == "" || adminEmailId == "") {
            thisController.notifyMsgFieldEmpty();
        } else if (!namePattern.test(adminName)) {
            thisController.notifyImproperName();
        } else if (!emailpattern.test(adminEmailId)) {
            thisController.notifyImproperEmailId();
        } else if (!contactNumberPattern.test(adminContactNumber)) {

            thisController.notifyImproperContactNumber();
        }
        else {
            var addedData = {

            };
            $.ajax({
                url: "/my-jeeva-api/provider-admin",

                method: 'POST',
                data: {
                    role: "PROCEDURE_ADMIN",
                    userEmail: document.getElementById("adminEmailId" + props.index).innerText.trim(),
                    userName: document.getElementById("adminName" + props.index).innerText.trim(),
                    userPhoneNumber: document.getElementById("adminContactNumber" + props.index).innerText.trim(),
                    healthSystemId: thisController.props.location.state.healthSystemId,
                    hospitalId: thisController.props.location.state.hospitalId,
                    serviceLineId: thisController.props.location.state.serviceLineId
                },
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token")
                },
                success: function (res) {
                    if (res.success === true) {
                            thisController.NotifyAdd();
                            thisController.state.disabled = false;
                            thisController.fetchProcedureAdminApi();
                    } else {
                        // thisController.NotifyFailToLoad();
                        thisController.state.disabled = false;
                    }
                },
                error: function (xhr, status, error) {
                    if (xhr.status == 401) {
                        window.location.href = "/my-jeeva/login";
                    }
                }
            })
        }

    }

    NotifyAdd() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Procedure Admin detail has been added successfully</b>, {
            position: "top-center",

        });

    }
    notifyImproperName() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please provide a valid name</b>, {
            position: "top-center"
        });
    }

    notifyFailedToAdd(response) {
        toast.dismiss();
        toast(<b>{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }

    makeCelleditable(props, e) {
        this.markAsBeingEdited(this.state.data[props.index].id);
    }
    markAsBeingEdited(id) {
        this.state.editedId = id;
        var stateObj = this.state;
        this.setState(stateObj);
    }

    updateApi(props, e) {
        var adminName = document.getElementById("adminName" + props.index).innerText.trim();
        var adminContactNumber = document.getElementById("adminContactNumber" + props.index).innerText.trim();
        var adminEmailId = document.getElementById("adminEmailId" + props.index).innerText.trim();
        var thisController = this
        // var pattern = new RegExp(/^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{1,5}|[0-9]{1,3})(\]?)$/);
        var contactNumberPattern = new RegExp(/^(?!.*\s\s)[+]?[\d- ]{5,15}$/);
        // new RegExp(/^(?=.*\d).+$/);
        var namePattern = new RegExp(/^([a-zA-Z\s])*$/);
        var emailpattern = new RegExp(/[a-zA-Z][a-zA-Z0-9]+@(?:[a-zA-Z0-9]+\.)+[A-Za-z]+$/);

        if (adminName == "" || adminContactNumber == "" || adminEmailId == "") {
            thisController.notifyMsgFieldEmpty();
        }
        else if (!emailpattern.test(adminEmailId)) {
            thisController.notifyImproperEmailId();
        } else if (!namePattern.test(adminName)) {
            thisController.notifyImproperName();
        } else if (!contactNumberPattern.test(adminContactNumber)) {
            thisController.notifyImproperContactNumber();
        }
        else {
            var saveData = {
                id: props.original.id,
                procedureId: thisController.props.location.state.procedureId,
                //serviceLineId: thisController.props.location.state.serviceLineId,
                // hospitalId: thisController.props.location.state.hospitalId,
                // healthSystemId: thisController.props.location.state.healthSystemId,
                userRole: "PROCEDURE_ADMIN",
                userEmailId: document.getElementById("adminEmailId" + props.index).innerText.trim(),
                userName: document.getElementById("adminName" + props.index).innerText.trim(),
                userPhoneNumber: document.getElementById("adminContactNumber" + props.index).innerText.trim()
            }

            $.ajax({
                url: "/my-jeeva-api/provider",

                method: 'PATCH',
                data: JSON.stringify(saveData),
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': "application/json"
                },
                success: function (res) {
                    if (res.success === true) {
                        thisController.state.editedId = "-1";
                        thisController.notifyUpdated();
                        thisController.state.disabled = false;
                        thisController.fetchProcedureAdminApi();
                    } else {
                        if (res.result != "") {
                            thisController.notifyFailedToUpdate(res.result);
                            thisController.state.disabled = false;
                        }
                        else {
                            thisController.notifyFailedToUpdate(res.result);
                            thisController.state.disabled = false;
                        }
                    }
                },
                error: function (xhr, status, error) {
                    if (xhr.status == 401) {
                        window.location.href = "/my-jeeva/login";
                    }
                }
            })
        }
    }

    notifyUpdated() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Procedure Admin details has been updated successfully</b>, {
            position: "top-center",

        });
    }

    notifyFailedToUpdate(response) {
        toast.dismiss();
        toast(<b>{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }

    validateCells(answer) {
        if ((answer == "")) {
            this.notifyMsgFieldEmpty();
            return false;
        }
        else {
            return true;
        }

    }

    notifyMsgFieldEmpty() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please fill all the fields</b>, {
            position: "top-center"
        });

    }

    deleteAdminApi = (props) => {
        let deleteRowViewController = this.state.data;
        let deleteApiViewController = this;
        var deleteConstructorVariables = this;

        if (props.id == "") {
            deleteApiViewController.setState({ deleteRow: true });
            deleteConstructorVariables.setState({ hideDeletePopup: false });
            deleteConstructorVariables.setState({ hideDeleteSuccessPopup: true });
            deleteRowViewController.splice(props.id, 1);
        } else {
            var deleteData = {
                id: props.id,
                emailId: props.userEmailId,
                userRole: 'PROCEDURE_ADMIN',
                healthSystemId: deleteApiViewController.props.location.state.healthSystemId,
                hospitalId: deleteApiViewController.props.location.state.hospitalId,
                serviceLineId: deleteApiViewController.props.location.state.serviceLineId,
            }
            $.ajax({
                url: "/my-jeeva-api/delete-user",

                method: 'POST',
                data: JSON.stringify(deleteData),
                headers: {
                    "Authorization": "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': "application/json"
                },
                success: function (res) {

                    if (res.success === true) {

                        deleteApiViewController.setState({ deleteRow: true });
                        deleteConstructorVariables.setState({ hideDeletePopup: false });
                        deleteRowViewController.splice(props.id, 1);
                        deleteConstructorVariables.notifyMsgDeleteSuccess();
                        deleteConstructorVariables.fetchProcedureAdminApi();

                    } else {
                        if (res.result != "") {
                            deleteConstructorVariables.notifyFailToDelete(res.result);
                        }
                        // deleteConstructorVariables.NotifyFailToLoad();
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/my-jeeva/login";
                    }
                }
            });
        }
    }
    notifyMsgDeleteSuccess() {
        toast.dismiss();
        toast(<b>
            <img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />
            &nbsp;&nbsp;Procedure Admin detail has been deleted successfully</b>, {
            position: "top-center"
        });
    }

    notifyFailToDelete(response) {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;{response}</b>, {
            position: "top-center"
        });
    }

    refreshData = (id) => {
        var refreshContent = this
        refreshContent = this.state.editedId = id;
        this.fetchProcedureAdminApi()
        this.setState({ disabled: false })
    }

    fetchProcedureAdminApi = () => {
        var thisController = this;
        $.ajax({
            url: "/my-jeeva-api/provider",

            method: 'GET',
            data: {
                procedureId: thisController.props.location.state.procedureId,
                role: "PROCEDURE_ADMIN"
            },
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token"),
            },

            success: function (res) {
                if (res.success === true) {
                    thisController.setState({
                        data: res.result,
                        disabled: false
                    })
                }
                else {
                    // thisController.NotifyFailToLoad();
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/my-jeeva/login";
                }
            }
        });
    }

    goBackFromSubTab = () => {
        var pageNum = this.props.location.state.pageNum;
        this.props.history.push({
            pathname: "/projectmgmt/procedure",
            state: {
                goBackToFaq: true,
                pageNum: pageNum,
                healthSystemId: this.props.location.state.healthSystemId,
                hospitalId: this.props.location.state.hospitalId,
                serviceLineId: this.props.location.state.serviceLineId
            }
        });
    }

    componentDidMount() {
        var faqid = this.props.location.state.faqid
        this.state.faqid = faqid;
        this.setState(this.state)
        setTimeout(() => {
            this.fetchProcedureAdminApi();
        }, 300);

        document.addEventListener("projectChanged", function (event) {
            window.location.href = "/my-jeeva/projectmgmt/manage-knowledge/faq";
        });
    }

    onPageChange = (e) => {
        this.setState({ pageNum: e })
    }

    render() {
        const { data } = this.state
        const columns = [

            {
                Header: <b>Name</b>,
                accessor: 'adminName',
                sortable: false,
                Cell: props => (
                    <div name="message" className="textarea"
                        type="text"
                        style={{ height: '5vh', background: 'white', resize: 'none', borderBottom: 'none', border: (props.original.id == this.state.editedId || props.original.id == "") ? '1px solid #D2D4DC' : 'none', borderRadius: (props.original.id == this.state.editedId || props.original.id == "") ? '2px' : 'none', paddingLeft: '2px' }}
                        id={"adminName" + props.index}

                        rows="1"
                        contentEditable={!((props.original.id == "") ? false :
                            props.original.id != this.state.editedId) ? "plaintext-only" : false}
                        suppressContentEditableWarning>{props.original.userName}

                    </div>)
            },
            {
                Header: <b>Email ID</b>,
                accessor: 'adminEmailId',
                sortable: false,
                Cell: props => (
                    <div name="message" className="textarea"
                        type="text"
                        style={{ height: '5vh', background: 'white', resize: 'none', borderBottom: 'none', border: (props.original.id == this.state.editedId || props.original.id == "") ? '1px solid #D2D4DC' : 'none', borderRadius: (props.original.id == this.state.editedId || props.original.id == "") ? '2px' : 'none', paddingLeft: '2px' }}
                        id={"adminEmailId" + props.index}

                        rows="1"
                        contentEditable={!((props.original.id == "") ? false :
                            props.original.id != this.state.editedId) ? "plaintext-only" : false}
                        suppressContentEditableWarning>{props.original.userEmailId}

                    </div>)
            },
            {
                Header: <b>Contact Number</b>,
                accessor: 'adminContactNumber',
                sortable: false,
                Cell: props => (
                    <div name="message" className="textarea"
                        type="text"
                        style={{ height: '5vh', background: 'white', resize: 'none', borderBottom: 'none', border: (props.original.id == this.state.editedId || props.original.id == "") ? '1px solid #D2D4DC' : 'none', borderRadius: (props.original.id == this.state.editedId || props.original.id == "") ? '2px' : 'none', paddingLeft: '2px' }}
                        id={"adminContactNumber" + props.index}

                        rows="1"
                        contentEditable={!((props.original.id == "") ? false :
                            props.original.id != this.state.editedId) ? "plaintext-only" : false}
                        suppressContentEditableWarning>{props.original.userPhoneNumber}

                    </div>)
            },

            {
                Header: <b>Action</b>,
                accessor: 'action',
                width: 100,
                sortable: false,
                Cell: props => (
                    <div id="action">

                        <button
                            //className="btn2 table-action-button "
                            style={{
                                backgroundColor: "#ffffff", border: "none",
                                marginTop: '-13px'
                            }}>
                            <img className="img-responsive"
                                style={{ marginTop: '8px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px' }}
                                title={(props.original.id == "") ||
                                    (this.state.data[props.index].id == this.state.editedId) ? 'Save' : 'Edit'}

                                src={(props.original.id == "") ?
                                    this.saveImageSrc : ((props.original.id != this.state.editedId) ?
                                        this.editImageSrc : this.saveImageSrc)}
                                onClick={(e) => {
                                    (props.original.id == "") ?
                                        this.addAdminApi(props, e) :
                                        (props.original.id == this.state.editedId) ?
                                            this.updateApi(props, e) :
                                            this.makeCelleditable(props, e);
                                }}
                            />
                        </button>
                        <button
                            style={{
                                backgroundColor: "#ffffff",
                                border: "none",
                                marginTop: '-9px', marginLeft: '-6px'
                            }} title="Delete">
                            <img className="img-responsive"
                                style={{
                                    marginTop: '6px',

                                    backgroundColor: '#282a65', borderRadius: '5px', padding: '1px'
                                }}
                                src={"./assets/images/baseline_delete_white_24dp.png"}
                                onClick={() => (props.original.id) === '' ?
                                    this.fetchProcedureAdminApi() :
                                    this.setState({
                                        hideDeletePopup: true, deletePropIndex: props.index,
                                        propsId: props.original
                                    })}
                            />
                        </button>

                    </div>
                ),

            },

        ]
        return (
            <div style={{ background: "#F9F9FB" }} id='procedureAdminTab'>
                {/* for toaster */}
                <link rel="stylesheet" href="assets/css/ReactToastify.css" />
                {/* for reactTable */}
                <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />

                <link rel="stylesheet" href="./assets/css/styles.css" />

                {/*for dialog component */}
                <link href="assets/css/ej2-base.css" rel="stylesheet" />
                <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                <link href="assets/css/screenResolution.css" rel="stylesheet" />
                {/* Font Awesome Icons */}
                <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                {/* IonIcons */}
                <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                {/* Select2 */}
                <link rel="stylesheet" href="plugins/select2/select2.min.css" />
                <link rel="stylesheet" href="assets/css/toggleButton.css" />

                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row">
                        </div>
                        <div className="row">
                            <div className="col-sm-4" style={{ marginTop: '16px' }}  >
                                <img src="assets/images/arrow.svg"
                                    style={{ paddingRight: "30%", cursor: 'pointer' }}
                                    onClick={this.goBackFromSubTab}
                                />
                            </div>
                            <div className="col-sm-4">
                                <h6 className="nav-item" style={{ color: '#282a65', textAlign: 'center', marginTop: '16px' }}>
                                    Procedure Admin</h6>
                                {/* <h6 className="taglineTxt" style={{ textAlign: 'center' }}>FAQ Answers</h6> */}
                            </div>
                            {/* Add button */}
                            <div className="col-sm-4" Align='right'>
                                <button className="btn action-button "
                                    title="Add"
                                    id="addMsg"
                                    onClick={this.state.disabled ? this.notifyMsgFieldEmpty : this.addRow}>
                                    <img src="assets/images/add_white_24dp.png" />
                                </button>
                                <button onClick={this.refreshData}
                                    title="Refresh"
                                    className="btn action-button">
                                    {/* style={{ width: '45px',margin: '5px' }}>Refresh */}
                                    <img src="./assets/images/refresh_white_24dp.png"></img>
                                </button>
                            </div>
                        </div>
                    </div>
                    {/* left Menu start here*/}
                    {/* Content Header (Page header) */}
                    {/* /.content-header */}
                    {/* Custom Tabs */}
                    <div className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-lg-12 ">
                                    <div className="card">
                                        {/* <div className="table-responsive manageClientTableBox"> */}
                                        {/* <ReactTable
                                            data={data}
                                            columns={columns}
                                            defaultPageSize={10}
                                            pageSizeOptions={[5, 10, 15]}
                                            onPageChange={this.onPageChange}
                                            page={this.state.pageNum}
                                        /> */}
                                    </div>
                                    <ToastContainer className="Toast-at-center" />

                                    {/*Dialog Component For Deletion Confirmation*/}
                                    <DialogComponent width='400px' animationSettings={this.settings}
                                        header='Procedure Admin' showCloseIcon={true} buttons={this.buttons}
                                        ref={dialog => this.dialogInstance = dialog} target='#procedureAdminTab'
                                        visible={this.state.hideDeletePopup} close={this.dialogClose}>
                                        <img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                                            content="" />&nbsp;Do you want to delete this procedure admin?&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Note: Press 'Yes' to delete or press 'No' to decline.</DialogComponent>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

export default ProcedureAdmin;


// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/ProcedureAdmin.js